// extracted by css-extract-rspack-plugin
export default {"controls":"controls-R_V41F"};